import { ChangeDetectionStrategy, Component, Injector, ViewChild } from '@angular/core';
import { WidgetBase } from '../../widget-content/base/widget-base';
import { WidgetContentDocumentListingComponent } from '../../widget-content/document-listing/document-listing';

@Component({
    selector: 'fi-widget-document-listing',
    templateUrl: './document-listing.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-widget-document-listing' },
    standalone: false,
})
export class WidgetDocumentListingComponent extends WidgetBase {
    constructor(injector: Injector) {
        super(injector);
    }

    @ViewChild(WidgetContentDocumentListingComponent, { static: false })
    documentListingContent: WidgetContentDocumentListingComponent;

    get isEmpty$() {
        return this.documentListingContent.isEmpty$;
    }
}
